import { ProductFormComponent } from '@theme/product-form';
import { ThemeEvents, CartAddEvent, CartUpdateEvent } from '@theme/events';

/**
 * A custom element that manages a upsell product form.
 *
 * @extends ProductFormComponent
 */
class UpsellProductFormComponent extends ProductFormComponent {
  requiredRefs = ['variantId', 'liveRegion', 'closeButton'];
 
  connectedCallback() {
    super.connectedCallback();
    this.defaultProductVariantId = parseInt(this.dataset.defaultProductVariantId || '0');
    this.offerProductVariantId = parseInt(this.dataset.offerProductVariantId || '0');
    this.isOfferProductNotAvailable = this.dataset.offerProductNotAvailable === 'true';
    document.addEventListener(ThemeEvents.cartUpdate, this.handleCartUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(ThemeEvents.cartUpdate, this.handleCartUpdate);
  }

  /**
   * Handles the cart update event.
   * @param {CartAddEvent|CartUpdateEvent } event - The cart update event
   */
  handleCartUpdate = (event) => {
    const { variantId } = this.refs;
    const cart = event.detail.resource;

    if (!cart || !variantId) return;

    const items = cart.items;
    const hasDefaultProductVariantInCart = items.find(item => item.variant_id === this.defaultProductVariantId);
    const hasOfferProductVariantInCart = items.find(item => item.variant_id === this.offerProductVariantId);

    this.hidden = hasDefaultProductVariantInCart || hasOfferProductVariantInCart || this.isOfferProductNotAvailable;
  }
  
  /**
   * Hides the upsell block.
   *
   * @param {Event} event - The event object.
   */
  hideUpsell(event) {
    event.preventDefault();
    this.hidden = true;
  }
}

if (!customElements.get('upsell-product-form-component')) {
  customElements.define('upsell-product-form-component', UpsellProductFormComponent);
}